<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="12">
        <shop-select  distributors  @update="storeChange" @init="initChange"></shop-select> <!--distributors wxshops 需要哪个api传哪个-->
      </el-col>
      <el-col :md="8" :lg="5">
        <el-input placeholder="公告内容" v-model="params.message" clearable><el-button slot="append" icon="el-icon-search" @click="numberSearch"></el-button></el-input>
      </el-col>
      <el-col :span="3" class="content-right">
        <el-button type="primary" icon="plus" @click="handleAdd">添加公告</el-button>
      </el-col>
    </el-row>
    <el-row>

    </el-row>
    <el-tabs type="border-card" v-model="activeName">
      <el-tab-pane label="公告列表" name="admin"></el-tab-pane>
      <el-table :data="list" :height="wheight-160" v-loading="loading">
        <el-table-column prop="distributor_notice_id" label="id"></el-table-column>
        <el-table-column prop="is_publish" label="是否公布">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.is_publish === 0 ? 'primary' : 'success'"
              disable-transitions>{{scope.row.is_publish == 0 ?'未公布' :'已公布'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="distributor_name" label="所属店铺">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.distributor_name === '' ? 'primary' : 'warning'"
              disable-transitions>{{scope.row.distributor_name }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序"></el-table-column>
        <el-table-column prop="type" label="公告类型">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.type === 0 ? 'primary' : 'success'"
              disable-transitions>{{scope.row.type == 0 ?'全部' :'指定'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="message" label="公告内容"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="operating-icons">
              <i class="iconfont icon-edit1" @click="handleUpdate(scope.row)"></i>
              <i class="mark iconfont icon-trash-alt1" @click="handleDelete(scope.$index, scope.row)"></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="total_count > params.pageSize" class="content-padded content-center">
        <el-pagination background
                       layout="prev, pager, next, total"
                       @current-change="handleCurrentChange"
                       :current-page.sync="params.page"
                       :total="total_count" :page-size="params.pageSize">
        </el-pagination>
      </div>
    </el-tabs>

    <el-dialog title="添加/编辑公告" :visible.sync="dialog" :close-on-click-modal="false">
      <el-form v-model="form" label-width="160px">
        <el-form-item label="所属店铺">
          <shop-select  distributors  @update="addSelectStoreChange" @init="initChange" :shopIdDefault="DistributorName"></shop-select>
          <!--distributors wxshops 需要哪个api传哪个-->
        </el-form-item>
        <el-form-item label="公告内容">
          <el-input type="textarea" v-model="form.message"  placeholder="请输入公告内容,不超过200字"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="form.sort" placeholder="请输入数字" style="width:100px"></el-input>
        </el-form-item>
        <el-form-item label="是否公布">
          <el-switch
            v-model="form.is_publish"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
        <el-form-item label="是否指定店铺">
          <el-switch
            v-model="form.type"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer content-center">
        <el-button type="primary" @click="handleSave">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getNoticeList,addNotice,updateNotice,delNotice} from '../../../api/marketing'
import shopSelect from '@/components/shopSelect'
export default {
  components: {
    shopSelect,
  },
  data () {
    return {
      dialog: false,
      activeName: 'admin',
      list: [],
      total_count: 0,
      loading: false,
      params: {
        page: 1,
        pageSize: 20
      },
      DistributorName:'',
      form: {
        distributor_id:  '',
        message: '',
        is_publish:false,
        sort: 0,
        type: false
      },
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {

    handleAdd(){
      this.dialog = true
      this.form.distributor_id= ''
      this.form.message = ''
      this.form.is_publish = false
      this.form.sort = 0
      this.form.type = false
    },
    addSelectStoreChange(data) {
      this.form.distributor_id = data.shop_id
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.loading = false
      this.getParams()
      this.getList()
    },
    storeChange (params) {
      params && params.shop_id
      this.params.distributor_id = params.shop_id
      this.params.page = 1
      this.getList()
    },
    initChange () {
      this.shopId = ''
    },
    numberSearch () {
      this.params.page = 1
      this.getList()
    },
    handleUpdate(row) {
      this.dialog = true
      this.form.distributor_id = row.distributor_id
      this.form.message = row.message
      this.form.sort = row.sort
      this.form.is_publish = (row.is_publish === 1 ? true:false)
      this.form.type = (row.type === 1 ? true :false)
      this.form.distributor_notice_id = row.distributor_notice_id
      this.DistributorName = row.distributor_name
    },
    handleDelete(index, row) {
      this.$confirm('此操作将删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delNotice(row.distributor_notice_id).then(response => {
          this.list.splice(index, 1)
          this.$message({
            type: 'success',
            message: '操作成功'
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    handleSave() {
      if (this.form.distributor_notice_id && this.form.distributor_notice_id !==undefined) {
        this.form.is_publish = (this.form.is_publish === true ? 1 : 0)
        this.form.type = (this.form.type === true ? 1 : 0)
        this.updateAction()
      } else {
        this.addAction()
      }
    },
    updateAction () {
      updateNotice(this.form.distributor_notice_id, this.form).then(res => {
        this.form = {
          distributor_id: '',
          message:'',
          is_publish:false,
          sort:0,
          type:false,
        }
        this.dialog = false
        this.getList()
        this.$message({ type: 'success', message: '操作成功' })
      })
    },
    addAction() {
      addNotice(this.form).then(res => {
        this.form = {
          distributor_id: '',
          message:'',
          is_publish:false,
          sort:0,
          type:false,
        }
        this.dialog = false
        this.getList()
        this.$message({ type: 'success', message: '操作成功' })
      })

    },
    getList () {
      this.loading = true
      getNoticeList(this.params).then(response => {
        if(response.data.data.list) {
          this.list = response.data.data.list
          this.total_count = Number(response.data.data.total_count)

        }
        this.loading = false
      })
    },
  },
  mounted () {
    this.getList()
  }
}
</script>

<style scoped lang="scss">
.upload-preview {
  text-align: center;
  max-width: 200px;
  border: 1px solid #ddd;
  padding: 10px;
  position: relative;
  img {
    max-width: 200px;
    margin: 0 auto;
  }
}
.text-ellipsis {
  display: inline-block;
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// distributornotice.vue?91c05fb4